module.exports = __webpack_public_path__ + "img/荣誉证书11_职业健康安全管理体系认证证书.d312bf9c.png";